/**
 * O token de redefinição de senha, tirado do endereço antes do PostHog subir.
 *
 * **O endereço é lido por tudo.** O link do e-mail chega como
 * `/nova-senha?token=...`, e o `registrarTela` já filtrava a busca para o
 * `$pageview` - mas o autocapture carrega o `$current_url` cru em todo clique,
 * e a gravação de sessão guarda o endereço da página ao começar. Com o token
 * ali, quem abrisse o replay certo teria em mãos um link que troca a senha de
 * outra pessoa enquanto ele não expira.
 *
 * Em vez de lembrar de filtrar cada leitor, o token sai do endereço antes de
 * existir leitor: o `main.tsx` chama `guardarTokenDeRedefinicao` antes de
 * iniciar o PostHog, e a tela o busca daqui. Sai do histórico do navegador
 * também, de brinde.
 *
 * Fica no `sessionStorage`, e não só em memória, para o recarregar da página
 * não transformar um link válido em "Link inválido". A aba fechada leva junto.
 */
const CAMINHO = '/nova-senha';
const CHAVE = 'titularis:token-de-redefinicao';

/** O endereço sem o token, e o token que estava nele. Pura, para ser testada. */
export function separarToken(endereco: string): { token: string | null; limpo: string } {
  const url = new URL(endereco);
  const token = url.pathname === CAMINHO ? url.searchParams.get('token') : null;
  if (!token) return { token: null, limpo: endereco };

  url.searchParams.delete('token');
  return { token, limpo: `${url.pathname}${url.search}${url.hash}` };
}

export function guardarTokenDeRedefinicao(): void {
  const { token, limpo } = separarToken(window.location.href);
  if (!token) return;

  try {
    sessionStorage.setItem(CHAVE, token);
  } catch {
    /*
     * Sem armazenamento (navegação privada restrita), o token fica no endereço:
     * perder a redefinição seria pior que o risco que esta função reduz.
     */
    return;
  }
  window.history.replaceState(window.history.state, '', limpo);
}

export function lerTokenDeRedefinicao(): string | null {
  try {
    return sessionStorage.getItem(CHAVE);
  } catch {
    return null;
  }
}

/** Depois de usado, o token não serve para mais nada e não tem por que ficar. */
export function esquecerTokenDeRedefinicao(): void {
  try {
    sessionStorage.removeItem(CHAVE);
  } catch {
    // Nada a fazer: a aba fechada limpa o mesmo.
  }
}
